import React from "react";
import classNames from "classnames/bind";
import styles from "../AddJobModal.module.scss";
import { ModalStep } from "../types/add-job.types";
import { CloseIcon } from "~/assets/icons";

const cx = classNames.bind(styles);

interface AddJobModalHeaderProps {
  currentStep: ModalStep;
  onClose: () => void;
}

const AddJobModalHeader: React.FC<AddJobModalHeaderProps> = ({
  currentStep,
  onClose,
}) => {
  return (
    <div className={cx("header")}>
      <button
        type="button"
        className={cx("close-button")}
        onClick={onClose}
        aria-label="Close"
      >
        <CloseIcon className={cx("close-icon")} />
      </button>
      <h2>Create New Job</h2>
      <div className={cx("info-header")}>
        <div className={cx("info-item")}>
          <div
            className={cx(
              "info-step",
              currentStep >= 1 ? "active" : "inactive"
            )}
          >
            <p>1</p>
          </div>
          <p
            className={cx(
              "info-text",
              currentStep >= 1 ? "active" : "inactive"
            )}
          >
            Select Contacts
          </p>
        </div>

        <div className={cx("info-item")}>
          <div
            className={cx(
              "info-step",
              currentStep >= 2 ? "active" : "inactive"
            )}
          >
            <p>2</p>
          </div>
          <p
            className={cx(
              "info-text",
              currentStep >= 2 ? "active" : "inactive"
            )}
          >
            Job Address
          </p>
        </div>

        <div className={cx("info-item")}>
          <div
            className={cx(
              "info-step",
              currentStep >= 3 ? "active" : "inactive"
            )}
          >
            <p>3</p>
          </div>
          <p
            className={cx(
              "info-text",
              currentStep >= 3 ? "active" : "inactive"
            )}
          >
            Job Details
          </p>
        </div>
      </div>
    </div>
  );
};

export default AddJobModalHeader;
